import type { Frequencia, LancarFrequenciaCommand } from '@/domain/model/Frequencia';
import type { FrequenciaGateway } from '@/application/port/out/FrequenciaGateway';
import type {
  ListFrequenciasByMatriculaUseCase, LancarFrequenciaUseCase,
} from '@/application/port/in/FrequenciaUseCase';

export class ListFrequenciasByMatriculaUseCaseImpl implements ListFrequenciasByMatriculaUseCase {
  constructor(private readonly gateway: FrequenciaGateway) {}
  execute(matriculaId: string): Promise<Frequencia[]> {
    return this.gateway.listByMatricula(matriculaId);
  }
}

export class LancarFrequenciaUseCaseImpl implements LancarFrequenciaUseCase {
  constructor(private readonly gateway: FrequenciaGateway) {}
  execute(command: LancarFrequenciaCommand): Promise<Frequencia> {
    return this.gateway.lancar(command);
  }
}
